
import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { AppUrl } from '../../common/constants/app-urls';
import { BookingAction } from '../constants/rent-basic-data';
import { BookingModif } from '../models/booking-modif.model';
import { Booking } from '../models/booking.model';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

@Injectable({
  providedIn: 'root',
})
export class RentService {
    //loggedIn = false;
  constructor(private http: HttpClient) {}

  addNewBooking(booking: Booking): Observable<any>{ 
    return this.http.post<any>(
        AppUrl.rentBookings+"/new", 
        booking, 
        httpOptions );
  }
  
  updateBooking(booking: Booking): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.rentBookings+"/update", 
      booking,
      httpOptions );  
  }

  updateBookingStatus(bookingId: number, status: string): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.rentBookings+"/"+bookingId+"/update-status", 
      {data: status},
      httpOptions );  
  }

  executeBookingAction(action: BookingAction, booking: Booking | BookingModif): Observable<any>{ 
          
    return this.http.post<any>(
      AppUrl.rentBookings+"/action/"+action, 
      booking,
      httpOptions );  
  }
  
  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
